module.exports = __webpack_public_path__ + "static/logos/icon-x-6a8b2111be4f035d5467c137d0f7b814.svg";